import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';
import { Estate } from '@/modules/estate/models/Estate';
import { OpsEstateRoute } from '@/modules/ops/constants/OpsEstateRoute';
import { OpsRoute } from '@/modules/ops/constants/OpsRoute';
import type { CustomRouter } from '@/types/router.types';

export class OpsDetailsRouteService extends BaseService {
  getRedirectRoute(router: CustomRouter, estate: Estate): string {
    if (
      router.previousRoute &&
      router.previousRoute.path !== router.currentRoute.value.path &&
      router.previousRoute.path.includes(OpsRoute.OPS) &&
      router.previousRoute.name &&
      typeof router.previousRoute.name === 'string'
    ) {
      return router.previousRoute.name;
    }

    return estate.isClearEstate
      ? this.getClearEstateRoute(estate)
      : this.getClearVaultRoute(estate);
  }

  private getClearEstateRoute(estate: Estate): string {
    if (estate.isInactive) {
      return OpsEstateRoute.SETTLEMENT_INACTIVE.name;
    }

    return estate.jurisdiction.isInCanada
      ? OpsEstateRoute.SETTLEMENT_CANADA.name
      : OpsEstateRoute.SETTLEMENT_US.name;
  }

  private getClearVaultRoute(estate: Estate): string {
    if (estate.isInactive) {
      return OpsEstateRoute.PLANNING_INACTIVE.name;
    }

    return estate.jurisdiction.isInCanada
      ? OpsEstateRoute.PLANNING_CANADA.name
      : OpsEstateRoute.PLANNING_US.name;
  }
}

export default new OpsDetailsRouteService();
